var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./LegalDocumentLayout.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-224b673a\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./LegalDocumentLayout.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/Layouts/LegalDocumentLayout.vue
// module id = 377
// module chunks = 1